import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Breadcrumb from '../../Breadcrumb';
import InfoBox from '../../InfoBox';
import Modal from '../../Modal';
import MatomoTrackSearch from '../../Matomo/matomo-track-search';
import FindCareHeader from '../../FindCare/findcare-header';
import FindCareForm from '../../FindCare/findcare-form';
import SearchList from './search-list';
import queryString from 'qs';

const FindCarePage = (props) => {
  const location = useLocation();
  const qs = queryString.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  // Shared state handling for Find Care components.
  // TODO: useContext
  const [findCareState, _setFindCareState] = useState({
    searchResultModifiers: {},
  });

  const setFindCareState = (key, value) => {
    if (!key || typeof key !== 'string') {
      throw new Error('You need to pass a valid key to find care state.');
    }
    _setFindCareState((state) => ({
      ...state,
      [key]: value,
    }));
  };

  return (
    <>
      <div className="row">
        <div className="columns">
          <Breadcrumb {...props.Breadcrumbs} Language={props.Language} />
        </div>
      </div>
      <main className="main">
        <div className="row">
          <Modal>
            <div id="content">
              <div className="small-12 columns">
                <FindCareHeader {...props.Content} />
                <FindCareForm {...props} />
              </div>

              <SearchList
                mapConfig={props.mapConfig}
                findCareState={[findCareState, setFindCareState]}
                SearchResult={props.Content && props.Content.SearchResult}
                location={props.location}
                IsPost={props.Content.IsPost}
                apiConfig={props.apiConfig}
                Translations={props.Content && props.Content.Translations}
                EmptySearchResultText={props.Content.EmptySearchResultText}
                hasAltLayout={props.hasAltLayout}
              />
            </div>
          </Modal>
          {props.Content &&
            (props.Content.InfoText || props.Content.LinkCollection) && (
              <div className="small-12 columns">
                <InfoBox {...props.Content} />
              </div>
            )}
        </div>
      </main>
      <MatomoTrackSearch
        Search={qs?.q}
        SearchCategory={qs?.caretype || 'Alla mottagningar'}
        SearchHits={props.Content?.SearchResult?.TotalHits}
        SearchLocation={qs?.location}
      />
    </>
  );
};

export default FindCarePage;
